import UIComponent from '../../common/UIComponent';
import './index.css';
export default class H5PlayBtn extends UIComponent {
  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    // this.isLive = interfaces.isLive;

    this.init();

    this.interfaces.on(VhallPlayer.PLAY, res => {
      this.isplay = true;
      this.h5playBtn.classList.remove('vh-player-line-player-play');
      this.h5playBtn.classList.add('vh-player-line-player-pause');
    });

    this.interfaces.on(VhallPlayer.PAUSE, res => {
      this.isplay = false;
      this.h5playBtn.classList.add('vh-player-line-player-play');
      this.h5playBtn.classList.remove('vh-player-line-player-pause');
    });
  }

  init() {
    this.h5playBtn = document.createElement('span');
    this.h5playBtn.setAttribute('class', 'vhallPlayerh5-playBtn vh-player-iconfont vh-player-line-player-play');
    this.h5playBtn.onclick = this.handlerBtnClick.bind(this);
    this.insertElement(this.elementId, this.h5playBtn);
  }

  handlerBtnClick() {
    !this.isplay ? this.interfaces.play() : this.interfaces.pause();
  }
}
